@if (showLoadingSignal()) {
  <div role="alert" aria-live="assertive" aria-atomic="false" aria-relevant="all" [attr.aria-label]="overlayMessage()" role="dialog" aria-modal="true">
    <div class="overlay">
      <p class="overlay__message">{{overlayMessage()}}</p>
      <common-progress-spinner [diameter]="45" [strokeWidth]="4" class="overlay__spinner" [ngClass]="{'overlay__spinner--oversized-coverage': oversized, 'overlay__fixed': !manualControlEnabled()}"></common-progress-spinner>
    </div>
  </div>
}